// extracted by mini-css-extract-plugin
export default {"shadowed":"Home_shadowed__JjwOy","fade-in":"Home_fade-in__wNGrL","hand":"Home_hand__s8qbt","wave":"Home_wave__mK7-U"};